module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg6.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Chicago’s North Side, Early to Mid 20th Century")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "pgbreak"
  })]), _c('div', {
    staticClass: "cap"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg7.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Neighborhood Associations Affiliated with the Lincoln Park Conservation Association")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282edd8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Fm01.vue
// module id = 72
// module chunks = 0